import dynamic from "next/dynamic"
import { Container, Dropdown, DropdownContent, Stack } from "@octopus-energy/coral/atoms"
import { HeaderActions, useCoralHeader } from "@octopus-energy/coral/organisms"
import { useAccountMenu } from "@/features/navigation/hooks/useAccountMenu"
import { useSession } from "@/lib/blueprint-auth/client"
import { DropdownZone } from "../DropdownZone"
import { NavigationMenu } from "../NavigationMenu"
import { LogoutButton } from "./LogoutButton"

function AccountMenuDesktop() {
    const { isMenuOpen } = useCoralHeader()
    const accountMenu = useAccountMenu()

    const { data: session } = useSession()

    if (isMenuOpen) {
        return null
    }

    return (
        <Dropdown
            offset={0}
            placement="bottom-end"
        >
            <DropdownZone data-testid="account-menu-dropdown">
                <NavigationMenu.Dropdown.Trigger>
                    <HeaderActions />
                </NavigationMenu.Dropdown.Trigger>
                {session?.isAuthenticated && (
                    <DropdownContent padding="small">
                        {accountMenu.map((item) => (
                            <NavigationMenu.Dropdown.Button
                                href={item.href}
                                key={item.key}
                                attributes={{
                                    "data-testid": `account-menu-dropdown-item-${item.key}`,
                                }}
                            >
                                {item.label}
                            </NavigationMenu.Dropdown.Button>
                        ))}

                        <LogoutButton variant="dropdown" />
                    </DropdownContent>
                )}
            </DropdownZone>
        </Dropdown>
    )
}

function AccountMenuMobile() {
    const accountMenu = useAccountMenu()
    const { data: session } = useSession()

    if (!session?.isAuthenticated) {
        return null
    }

    return (
        <Dropdown
            offset={0}
            placement="bottom-start"
        >
            <Stack
                flexDirection="column"
                gap="sm"
                data-testid="account-menu-dropdown"
            >
                {accountMenu.map((item) => (
                    <NavigationMenu.Sub.Item
                        subItem={item}
                        key={item.label}
                        attributes={{ "data-testid": `account-menu-dropdown-item-${item.key}` }}
                    />
                ))}

                <Container marginLeft="sm">
                    <LogoutButton variant="sub" />
                </Container>
            </Stack>
        </Dropdown>
    )
}

export const AccountMenu = {
    Desktop: dynamic(async () => AccountMenuDesktop, { ssr: false }), // prevent hydration errors
    Mobile: AccountMenuMobile,
    messages: [...LogoutButton.messages, ...useAccountMenu.messages] as const,
}
